import { defineComponent, ref, reactive, onBeforeMount } from 'vue';
import { navigator } from '@tencent/vb-app-bridge';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { accountCheck, RESULTCODE } from '@tencent/vb-web-base/dist/accountTips';
import { to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import { TButton, TModal } from '@tencent/web-vbui';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { Modal } from './components';
import ClipboardJS from 'clipboard';
import { GetInviteCodeMerchantActInfo, CheckActivityRule } from '../../core/network/NodeAPI';
import Contract from '@tencent/vb-web-contract';
import { ProductInfoMap } from '@common/core/help/constant';
import { getUrlQuery } from '@common/utils/param';
export default defineComponent({
    components: {
        TButton,
        Modal,
        TModal,
    },
    setup() {
        const { setTitle, showModalError } = baseMixins();
        setTitle('商户邀请码');
        const isModalShow = ref(false);
        const btnDisable = ref(false);
        const btnTxt = ref('立即參與');
        const isOutdate = ref(false);
        // 活动页面配置
        const configInfo = reactive({
            actTime: '',
            actContent: '',
            inviteCode: '',
            guideList: [],
            modalContent: '',
            tipsList: [],
        });
        const getConfigInfo = async () => {
            const [data, err] = await to(GetInviteCodeMerchantActInfo('invite-code-merchant'));
            if (err) {
                showModalError(err.message, err.code);
            }
            if (data) {
                isOutdate.value = data.isOutdate || false;
                const lang = i18n.getLang() || 'zh-CN';
                configInfo.inviteCode = data.inviteCode;
                configInfo.actTime = data[`actTime_${lang}`];
                configInfo.actContent = data[`actContent_${lang}`];
                configInfo.modalContent = data[`modalContent_${lang}`];
                try {
                    configInfo.guideList = JSON.parse(data[`guideList_${lang}`]);
                    configInfo.tipsList = JSON.parse(data[`tipsList_${lang}`]);
                }
                catch (err) {
                    showModalError('配置数据格式错误');
                }
            }
        };
        // 是否有活动资格
        const checkActivityRule = async () => {
            const [data, err] = await to(CheckActivityRule(configInfo.inviteCode));
            if (err) {
                showModalError(err.message, err.code);
            }
            if (data.pass_mark === 2) {
                isModalShow.value = true;
                btnTxt.value = '您不符合活動參與條件';
                btnDisable.value = true;
            }
        };
        onBeforeMount(async () => {
            spin.show();
            await getConfigInfo();
            spin.hide();
            const res = await accountCheck({
                needAutoLogin: true,
                loginReload: false,
                needActivateModal: true,
                needOpenModal: true,
            });
            if (res.code !== RESULTCODE.SUCCESS) {
                navigator.pop();
                // 检测不成功 组件会走其他异常流程比如拉起开户 激活弹层
                return;
            }
            checkActivityRule();
        });
        // 查看协议
        const checkProto = () => {
            const contract = new Contract({
                key: 'loanPromotionTerms',
                autoSign: false,
                containerType: 'dialog',
                needAgree: false,
                needCheckBox: false,
                hideBtn: true,
                needTitle: false,
            });
            contract.preview();
        };
        // 立即参与
        const handleClick = async () => {
            const senceId = getUrlQuery('senceId') || '';
            reportStatistics({
                evtName: 'joinBtnClick',
                desc: '商家邀请码活动页面立即参与按钮点击',
            });
            window.top.location.href = `/h5/walletLoan/app/index.html?senceId=${senceId}&product_no=${ProductInfoMap.DEFAULT}&activeTag=${ProductInfoMap.DEFAULT}&inviteCode=${configInfo.inviteCode}&from=InviteCodeMerchant#/limit`;
        };
        // 复制邀请码
        const copyCode = () => {
            const clipboard = new ClipboardJS('.copy');
            clipboard.on('success', () => {
                toast.show({
                    title: '复制成功',
                });
                clipboard.destroy();
            });
            clipboard.on('error', (err) => {
                console.log(err);
                toast.show({
                    title: '复制失败',
                });
                clipboard.destroy();
            });
        };
        // 活动过期弹窗确认按钮
        const confirmHandler = () => {
            navigator.pop();
        };
        return {
            configInfo,
            isModalShow,
            btnDisable,
            btnTxt,
            checkProto,
            handleClick,
            copyCode,
            isOutdate,
            confirmHandler,
        };
    },
});
